import { render, staticRenderFns } from "./SecaoForm.vue?vue&type=template&id=36fd959b&scoped=true"
import script from "./SecaoForm.vue?vue&type=script&lang=js"
export * from "./SecaoForm.vue?vue&type=script&lang=js"
import style0 from "./SecaoForm.vue?vue&type=style&index=0&id=36fd959b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fd959b",
  null
  
)

export default component.exports